import React,{useState} from 'react';
import './navbar.css';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import logo from '../../assets/persbetechLogo3.png';

const Menu = () =>(
  <>
  <p><a className='home-btn' href="#home">Home</a></p>
  <p><a className='abt-btn' href="#wpt">About Us</a></p>
  <p><a className='service-btn' href="#features">Services</a></p>
  <p><a className='proj-btn' href="#projects">Projects</a></p>
  {/* <p><a className='contact-btn' href="#contact">Contact Us</a></p> */}
  </>
)


const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <div className='pt__navbar'>
        <div className='pt__navbar-links'>
            <div className='pt__navbar-links_logo'>
            <img src={logo} alt="logo" />
            </div>
            
            <div className='pt__navbar-links_container'>
              <Menu/>
            </div>
        </div>

        <div className='pt__navbar-sign'>
          {/* <p>Sign In</p> */}
          <a href="#contact"> <button type='button'>Lets Talk</button></a>
          
        </div>

        <div className="pt__navbar-menu">
        {toggleMenu
          ? <RiCloseLine color="#fff" size={27} onClick={() => setToggleMenu(false)} />
          : <RiMenu3Line color="#fff" size={27} onClick={() => setToggleMenu(true)} />}
        {toggleMenu && (
        <div className="pt__navbar-menu_container scale-up-center">
          <div className="pt__navbar-menu_container-links">
            <Menu/>
          </div>
          <div className="pt__navbar-menu_container-links-sign">
            {/* <p>Sign in</p> */}
            {/* <button type="button">Sign up</button> */}
          <a href="#contact"> <button type='button'>Contact</button></a>
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default Navbar